import { defineMessages } from 'react-intl';

import ListingCardsEdit from './ListingCardsEdit';
import ListingCardsView from './ListingCardsView';

// import iconSVG from '@plone/volto/icons/add-on.svg';
import iconSVG from '@plone/volto/icons/cards.svg';

defineMessages({
  listingCards: {
    id: 'Listing cards',
    defaultMessage: 'Listing cards',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.listingCardsBlock = {
    id: 'listingCardsBlock',
    title: 'Listing cards',
    group: 'listing',
    icon: iconSVG,
    view: ListingCardsView,
    edit: ListingCardsEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
